import { SHButton, SHDialog, SHStack } from "@components/design-systems";
import { DisqualifyAllProductsDialogProps } from "@models/platform-analysis/entities/analysis";
import { getDialogBody, getDialogHeader } from "./utils";

type Props = {
  disqualifyProps?: DisqualifyAllProductsDialogProps;
  isSubmitting: boolean;
  onSubmit: () => void;
  onClose: () => void;
};
export const HasUndecidedPlatformDialog = ({
  disqualifyProps,
  isSubmitting,
  onSubmit,
  onClose,
}: Props) => {
  if (!disqualifyProps) return null;

  return (
    <SHDialog
      open
      maxWidth={false}
      width={656}
      disableEscapeKeyDown
      disableBackdropClick
      header={getDialogHeader(disqualifyProps)}
      body={getDialogBody(disqualifyProps)}
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            variant="text"
            size="extraMedium"
            onClick={onClose}
          >
            Cancel
          </SHButton>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            Yes, disqualify
          </SHButton>
        </SHStack>
      }
    />
  );
};
